import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 84,
  label: "IPC大类申请量分析",
  chart: charts.lineAndBar,
  definition: {
    rowDims: [{ name: "shortIpc", label: "IPC大类", limit: 10, needTotal: true }],
    colDims: [],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    showNoDataDims: true
  },
  chartOption: {
    chartType: ChartType.BAR,
    title: "IPC大类申请量分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: false,
    hideLegend: false,
    hideToolbox: false
  }
};
